import { render } from "./VoiceInput.vue?vue&type=template&id=267e2ee7&scoped=true"
import script from "./VoiceInput.vue?vue&type=script&lang=js"
export * from "./VoiceInput.vue?vue&type=script&lang=js"

import "./VoiceInput.vue?vue&type=style&index=0&id=267e2ee7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267e2ee7"]])

export default __exports__